(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["premium-you-may-also-like"] && !Shopify.designMode) return;
  try {
    const productRecommendationsSection =
  document.querySelector('.product-recommendations');

if (productRecommendationsSection) {

  const url =
    productRecommendationsSection.dataset.url;

  fetch(url)

    .then((response) => response.text())

    .then((text) => {

      const html = document.createElement('div');

      html.innerHTML = text;

      const recommendations =
        html.querySelector('.product-recommendations');

      if (
        recommendations &&
        recommendations.innerHTML.trim().length
      ) {

        productRecommendationsSection.innerHTML =
          recommendations.innerHTML;

      }

    })

    .catch((error) => {

      console.error(
        'Product recommendations error:',
        error
      );

    });

}
  } catch(e) { console.error(e); }
})();

})();
